import { useRequest } from 'ahooks';
import React, { FC, useMemo } from 'react';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import { getAsrFilterConfigAsrEngineByLanguageType } from 'src/api/asr-filter-config/asr/engine/{languageType}';
import UdeskLocales from 'UdeskLocales';

export interface TemplateProps extends SelectProps<number> {
    languageType?: number;
}

const Template: FC<TemplateProps> = (props) => {
    const { languageType, ...restProps } = props;

    const { data } = useRequest(
        () =>
            getAsrFilterConfigAsrEngineByLanguageType({
                segments: { languageType: languageType! },
            }),
        {
            ready: !!languageType,
            refreshDeps: [languageType],
        }
    );

    const options = useMemo(() => {
        return data?.data?.map((d) => {
            return {
                label: d.name!,
                value: d.asrEngineType!,
                disabled: d.status === 0,
            };
        });
    }, [data?.data]);

    return (
        <Select
            style={{ width: 300 }}
            placeholder={
                /* 请选择 */ UdeskLocales['current'].components.aSRModelSelect.index.pleaseSelect
            }
            options={options}
            {...restProps}
        />
    );
};

export default Template;
